import { Colors, Router, Storage } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column } from '@lightningjs/ui-components';
import PopupButton from './PopupButton';
import { findCorrectStream } from '../../../utils/helpers';
import { finishWatching } from '../../../api/movies';

const Buttons = [
  {
    id: 1,
    title: 'Up Next',
    icon: { iconUrl: 'images/up-next.svg', iconWidth: 28, iconHeight: 20 },
    buttonColor: '#292929',
    borderColor: '#292929',
    focusColor: '#292929',
    unfocusColor: '#292929',
    unfocusBorderColor: '#292929',
  },
  {
    id: 2,
    title: 'Watch Credits',
    icon: { iconUrl: 'images/play.svg', iconWidth: 20, iconHeight: 23 },
    buttonColor: '#707070',
    borderColor: '#ffffff',
    focusColor: '#02AC25',
    unfocusColor: '#707070',
    unfocusBorderColor: '#707070',
  },
];

export default class PopupModal extends Lightning.Component {
  static _template() {
    return {
      w: 553,
      h: 329,
      rect: true,
      x: 73,
      y: 42,
      visible: false,
      color: Colors('#807F84').alpha(0.5).get(),
      // shader: {
      //   type: Lightning.shaders.RoundedRectangle,
      //   radius: 10,
      // },
      texture: Lightning.Tools.getRoundRect(
        552,
        329,
        10,
        5,
        Colors('#ffffff').alpha(1).get(),
        true,
        Colors('#807F84').get()
      ),

      Wrapper: {
        ImagePoster: {
          x: 104 - 73,
          y: 78 - 42,
          w: 183,
          h: 258,
          rect: true,
          color: Colors('#fafafa').get(),
        },
        Buttons: {
          x: 313 - 73,
          y: 178 - 42,
          type: Column,
          collision: true,
          items: Buttons.map((button, index) => ({
            index,
            collision: true,
            type: PopupButton,
            button,
          })),
        },
      },
    };
  }

  set previousID(val) {
    this._previousID = val;
  }

  set data(val) {
    this._data = val;
  }

  get _Buttons() {
    return this.tag('Buttons');
  }

  get _ImagePoster() {
    return this.tag('ImagePoster');
  }
  _enable() {
    this._ImagePoster.patch({
      src: this._data?.cover_art,
    });
    this._Buttons.items[0]._createCountDown();
  }

  _removeFirstAndSave() {
    return new Promise((resolve, reject) => {
      try {
        // Preuzmi vrednost 'VODList' iz localStorage i parsiraj je u niz
        let VODList = JSON.parse(localStorage.getItem('VODList'));

        if (Array.isArray(VODList) && VODList.length > 0) {
          // Ukloni prvi element iz niza
          VODList.shift();

          // Sačuvaj ažurirani niz nazad u localStorage
          localStorage.setItem('VODList', JSON.stringify(VODList));

          // Vraća se uspešno ažurirani niz
          resolve(VODList);
        } else {
          // Ako VODList nije niz ili je prazan
          reject('VODList is not a valid array or is empty.');
        }
      } catch (error) {
        // Obrada eventualnih grešaka
        reject(error);
      }
    });
  }

  $PlayNextMovie() {
    let profileId = Storage.get('profileId');
    let defaultValue = Storage.get(`audiosubtitles-${profileId}`);
    this._removeFirstAndSave().then(() => {
      let audio_video = findCorrectStream(this._data);
      Router.navigate(`player/${this._data.id}`, {
        currentTime: 0,
        subtitle: audio_video.subtitle,
        videoUrl: audio_video.videoStream,
        videoDuration: this._data.duration,
        introEndsAt: this._data.languages[defaultValue.audio]?.intro_ends_at,
        movieId: this._data.id,
        movieInfo: this._data,
        credits_start_at: audio_video.credits_start_at,
      });
      localStorage.setItem('CurrentVOD', this._data.id);
      finishWatching(this._previousID);
      this.fireAncestors('$setDefaultFocus');
    });
  }

  $setIndex(index) {
    this._Buttons.selectedIndex = index;
  }

  _getFocused() {
    return this.tag('Buttons');
  }
}
